import React, { type FC } from 'react'
import { useParams } from 'react-router-dom'

import { Chat, type ChatParams } from '../screens/Chat'

export const ChatWrapper: FC = () => {
  const { scenario_slug } = useParams<ChatParams>()
  return <Chat key={scenario_slug} />
}
